"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SUB_NAVIGATION_WIDTH = exports.PAGE_HEADER_BAR_HEIGHT = exports.NOTIFICATION_LIST_STEP_AMOUNT = exports.NOTIFICATION_LIST_DEFAULT_AMOUNT = exports.NAVIGATION_BAR_LOGO_HEIGHT = exports.NAVIGATION_BAR_HEIGHT = exports.METRIC_UNITS = exports.METRICS_DEFAULT_TIME_FRAME_IN_HOURS = exports.MENU_PROFILE_ITEM_HEIGHT = exports.MENU_ITEM_HEIGHT = exports.GRAPH_HEIGHT = exports.FOOTER_NAVIGATION_BAR_HEIGHT = exports.EMPTY_STATE_IMAGE_SIZE_TABLET = exports.EMPTY_STATE_IMAGE_SIZE_DESKTOP = exports.COMPARISON_FOOTER_HEIGHT = exports.BRUSH_PADDING = exports.BRUSH_HEIGHT = void 0;
var Layout = {
  navbarHeight: 65,
  navbarLogoHeight: 35,
  pageHeaderBarHeight: 110,
  footerNavbarHeight: 90,
  subNavWidth: 370,
  menuItemHeight: 60,
  menuProfileItemHeight: 100,
  emptyStateImageSizeDesktop: 264,
  emptyStateImageSizeTablet: 200
};
var NAVIGATION_BAR_HEIGHT = exports.NAVIGATION_BAR_HEIGHT = Layout.navbarHeight;
var NAVIGATION_BAR_LOGO_HEIGHT = exports.NAVIGATION_BAR_LOGO_HEIGHT = Layout.navbarLogoHeight;
var PAGE_HEADER_BAR_HEIGHT = exports.PAGE_HEADER_BAR_HEIGHT = Layout.pageHeaderBarHeight;
var FOOTER_NAVIGATION_BAR_HEIGHT = exports.FOOTER_NAVIGATION_BAR_HEIGHT = Layout.footerNavbarHeight;
var SUB_NAVIGATION_WIDTH = exports.SUB_NAVIGATION_WIDTH = Layout.subNavWidth;
var MENU_ITEM_HEIGHT = exports.MENU_ITEM_HEIGHT = Layout.menuItemHeight;
var MENU_PROFILE_ITEM_HEIGHT = exports.MENU_PROFILE_ITEM_HEIGHT = Layout.menuProfileItemHeight;
var EMPTY_STATE_IMAGE_SIZE_DESKTOP = exports.EMPTY_STATE_IMAGE_SIZE_DESKTOP = Layout.emptyStateImageSizeDesktop;
var EMPTY_STATE_IMAGE_SIZE_TABLET = exports.EMPTY_STATE_IMAGE_SIZE_TABLET = Layout.emptyStateImageSizeTablet;
var GRAPH_HEIGHT = exports.GRAPH_HEIGHT = 300;
var BRUSH_HEIGHT = exports.BRUSH_HEIGHT = 60;
var BRUSH_PADDING = exports.BRUSH_PADDING = 40;
var COMPARISON_FOOTER_HEIGHT = exports.COMPARISON_FOOTER_HEIGHT = 108;
var METRICS_DEFAULT_TIME_FRAME_IN_HOURS = exports.METRICS_DEFAULT_TIME_FRAME_IN_HOURS = 8;
var NOTIFICATION_LIST_DEFAULT_AMOUNT = exports.NOTIFICATION_LIST_DEFAULT_AMOUNT = 5;
var NOTIFICATION_LIST_STEP_AMOUNT = exports.NOTIFICATION_LIST_STEP_AMOUNT = 5;
var METRIC_UNITS = exports.METRIC_UNITS = {
  C: '°C',
  cP: 'cP',
  'g/cm3': 'g/cm3',
  rpm: '1/min',
  '1/min': '1/min',
  kWh: 'kWh',
  h: 'h',
  '%': '%',
  'm/s': 'm/s',
  A: 'A',
  'l/h': 'l/h',
  bar: 'bar',
  'pa.s': 'Pa·s',
  W: 'W',
  kW: 'kW'
};
var _default = exports["default"] = Layout;